import { useEffect } from "react";

import { trackEvent } from "./analytics";

// Many video links on the landing come from CMS content, so we can't attach a
// handler to each <a> in JSX. Instead we delegate: one document-level click
// listener detects clicks on any YouTube link and reports which page section it
// lives in (via the nearest <section id="…">). Fires a single "Video Play"
// event with the section id as the label, so GA4 shows which button/section
// opened the video.
const isYoutubeHref = (href) =>
  /youtube\.com\/watch|youtu\.be\/|youtube\.com\/embed/i.test(href);

const useVideoLinkTracking = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return undefined;
    if (typeof document === "undefined") return undefined;

    const onClick = (event) => {
      const link =
        event.target && event.target.closest && event.target.closest("a");
      if (!link) return;

      const href = link.getAttribute("href") || "";
      if (!isYoutubeHref(href)) return;

      const section = link.closest("section");
      const label = (section && section.id) || "unknown";

      trackEvent("Video Play", {
        category: "Video",
        label, // id of the parent <section> the link sits in
        video_url: href,
      });
    };

    // Capture phase so we still record the click before the browser navigates
    // away to YouTube.
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, [enabled]);
};

export default useVideoLinkTracking;
